<template>
	<div class="Login Register">
		<div class="login-page">
			<div class="login-page__bg" aria-hidden="true">
				<div class="login-page__mesh"></div>
				<img class="login-page__photo" src="../assets/img/loginBg.jpg" alt="" />
			</div>

			<div class="login-page__shell login-page__shell--register">
				<div class="login-card">
					<header class="login-card__brand">
						<img class="login-card__logo" src="@/assets/maitu-logo.svg" alt="麦图光电" />
						<h1 class="login-card__title">创建经销商账号</h1>
						<p class="login-card__subtitle">手机号验证 · 设置登录密码 · 即刻使用</p>
					</header>

					<el-alert
						v-if="!registerOpen && !statusLoading"
						class="register-closed-alert"
						title="当前暂未开放注册"
						type="warning"
						description="请联系管理员开通账号，或使用已有账号登录。"
						show-icon
						:closable="false"
					/>

					<el-form
						ref="registerForm"
						:model="registerForm"
						:rules="rules"
						class="login-form register-form"
						@submit.native.prevent="submitForm('registerForm')"
					>
						<el-form-item prop="username">
							<label class="login-field__label">手机号</label>
							<el-input
								v-model="registerForm.username"
								class="login-field__input"
								:clearable="clearable"
								:disabled="!registerOpen"
								placeholder="请输入手机号"
								prefix-icon="el-icon-mobile-phone"
							/>
						</el-form-item>

						<el-form-item prop="code">
							<label class="login-field__label">验证码</label>
							<div class="register-code-row">
								<el-input
									v-model="registerForm.code"
									class="login-field__input register-code-input"
									:disabled="!registerOpen"
									placeholder="短信验证码"
									prefix-icon="el-icon-message"
								/>
								<button
									type="button"
									class="register-code-btn"
									:class="{ 'register-code-btn--disabled': codeStatus || !registerOpen }"
									:disabled="codeStatus || !registerOpen"
									@click="getCode"
								>
									{{ codeStatus ? `还剩 ${codeTime} 秒` : btnTxt }}
								</button>
							</div>
						</el-form-item>

						<el-form-item prop="password">
							<label class="login-field__label">登录密码</label>
							<el-input
								v-model="registerForm.password"
								class="login-field__input"
								type="password"
								:show-password="passStatus"
								:clearable="clearable"
								:disabled="!registerOpen"
								placeholder="6~8 位数字或字母"
								prefix-icon="el-icon-lock"
							/>
						</el-form-item>

						<el-form-item prop="psd">
							<label class="login-field__label">确认密码</label>
							<el-input
								v-model="registerForm.psd"
								class="login-field__input"
								type="password"
								:show-password="passStatus"
								:clearable="clearable"
								:disabled="!registerOpen"
								placeholder="再次输入密码"
								prefix-icon="el-icon-lock"
								@keyup.enter.native="submitForm('registerForm')"
							/>
						</el-form-item>

						<el-form-item class="login-form__submit">
							<el-button
								type="primary"
								class="login-submit"
								:loading="registerStatus"
								:disabled="!registerOpen"
								native-type="submit"
								@click="submitForm('registerForm')"
							>
								{{ registerStatus ? '注册中…' : '确认注册' }}
							</el-button>
						</el-form-item>
					</el-form>

					<footer class="login-card__foot">
						<span class="login-card__hint">已有账号？</span>
						<el-link type="primary" :underline="underline" @click="goLogin">去登录</el-link>
					</footer>
				</div>

				<aside class="login-visual" aria-hidden="true">
					<div class="login-visual__frame">
						<img src="../assets/img/banner.jpg" alt="" />
						<div class="login-visual__overlay">
							<p class="login-visual__tag">Join the Network</p>
							<h2>加入麦图供应链<br />开启数字化报价协同</h2>
							<ul class="login-visual__features">
								<li>快速开通账号</li>
								<li>产品报价权限</li>
								<li>客户订单管理</li>
							</ul>
						</div>
					</div>
				</aside>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Register',
		data() {
			var validateMobile = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入手机号'));
				} else if (!this.re_mobile(value)) {
					callback(new Error('请正确输入手机号'));
				} else {
					callback();
				}
			};
			var validateCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else if (value.length < 6 || value.length > 8) {
					callback(new Error('请输入6~8位数字或字母'));
				} else if (this.registerForm.psd !== '') {
					this.$refs.registerForm.validateField('psd');
					callback();
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value.length < 6 || value.length > 8) {
					callback(new Error('请输入6~8位数字或字母'));
				} else if (value !== this.registerForm.password) {
					callback(new Error('两次输入密码不一致'));
				} else {
					callback();
				}
			};
			return {
				clearable: !0,
				passStatus: !0,
				underline: !1,
				registerStatus: !1,
				registerOpen: !0,
				statusLoading: !0,
				registerForm: {
					username: '',
					code: '',
					password: '',
					psd: '',
					pid: ''
				},
				rules: {
					username: [{ validator: validateMobile }],
					code: [{ validator: validateCode }],
					password: [{ validator: validatePass }],
					psd: [{ validator: validatePass2 }]
				},
				btnTxt: '获取验证码',
				codeStatus: !1,
				codeTime: 60
			}
		},
		created() {
			this.loadRegisterStatus();
		},
		methods: {
			loadRegisterStatus() {
				const that = this
				that.statusLoading = !0
				that.$fetch('addons/hlm/api.User/registerStatus').then(function(res) {
					if (res.code == 1 && res.data) {
						that.registerOpen = Number(res.data.open) === 1
					}
				}).catch(function() {
					that.registerOpen = !0
				}).finally(function() {
					that.statusLoading = !1
				})
			},
			getCode() {
				let that = this, status = 1
				if (!that.registerOpen || that.codeStatus) return
				that.$refs.registerForm.validateField('username', (res) => {
					if (res != '') status = 2
				});
				if (status == 2) return
				let params = { mobile: that.registerForm.username }
				that.$fetch('addons/hlm/api.User/send', params).then(function(res) {
					if (res.code == 1) {
						that.$message({
							message: '获取验证码成功',
							type: 'success',
							duration: 1500,
							center: !0
						})
						that.changeCode()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			changeCode() {
				let that = this
				that.codeStatus = !0
				let times = setInterval(() => {
					if (that.codeTime > 0) {
						that.codeTime = that.codeTime - 1
					} else {
						clearInterval(times)
						that.codeStatus = !1
						that.codeTime = 60
						that.btnTxt = '重新获取'
					}
				}, 1000)
			},
			submitForm(registerForm) {
				let that = this
				if (!that.registerOpen || that.registerStatus) return
				that.$refs[registerForm].validate((valid) => {
					if (valid) {
						that.registerStatus = !0
						that.$fetch('addons/hlm/api.User/register', that.registerForm).then(function(res) {
							if (res.code == 1) {
								that.$message({
									message: '注册成功',
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.registerStatus = !1
										that.$router.replace('/')
									}
								});
							} else {
								that.registerStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.registerStatus = !1
						})
					}
				});
			},
			re_mobile(mobile) {
				return /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(19[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(16[0-9]{1}))+\d{8})$/.test(mobile)
			},
			goLogin() {
				this.$router.replace('/')
			}
		}
	};
</script>

<style src="../assets/css/login.css"></style>
<style src="../assets/css/register.css"></style>
